import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DecimalPipe } from '@angular/common';
import { ItemStockAmount, StockLocationInfo } from '../../../types/item-stock-amount';

import {
  BreakpointService,
  FormatPipe,
  CardComponent,
  BadgeComponent,
} from '@softline/ui-core';
import { IconComponent } from '@softline/ui-core';
import { InterpolatePipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-lagerstaende',
  imports: [
    CdkAccordionModule,
    DecimalPipe,
    FormatPipe,
    IconComponent,
    InterpolatePipe,
    TranslatePipe,
    CardComponent,
    BadgeComponent,
  ],
  templateUrl: './lagerstaende.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Lagerstaende {
  private readonly breakpointService = inject(BreakpointService);
  readonly isMobile = this.breakpointService.isMobile;

  readonly data = input.required<ItemStockAmount | null>();
  readonly expanded = input.required<boolean>();
  readonly showNextOrderDate = input.required<boolean>();
  readonly showBewegungen = output<{ stockLocation: StockLocationInfo }>();
}
